<script setup lang="ts">
import { ref, watch } from "vue"
import { GDialog } from 'gitart-vue-dialog'
import i18n from '@/lang/i18n';

type Props = {
  modalState: boolean,
  title?: string,
  titleClass?: string,
  subTitle?: string,
  subTitleClass?: string,
  note?: string,
  noteClass?: string,
  leftBtnName?: string | null,
  leftBtnClass?: string,
  rightBtnName?: string | null,
  rightBtnClass?: string,
  modalMaxWidth?: string,
  leftLoading?: boolean,
  rightLoading?: boolean,
};
const props = withDefaults(defineProps<Props>(), {
  modalState: false,
  title: i18n.global.t('common.confirmationModal.title'),
  titleClass: 'confirmation-modal-title',
  subTitleClass: 'confirmation-modal-subtitle',
  noteClass: 'confirmation-modal-note',
  leftBtnName: i18n.global.t('common.confirmBtn'),
  leftBtnClass: 'exec-btn',
  leftLoading: false,
  rightBtnName: i18n.global.t('common.cancelBtn'),
  rightBtnClass: 'reset-btn',
  rightLoading: false,
});
const localModalState = ref(false)

watch(() => props.modalState, (value) => {
  localModalState.value = value
})

const emits = defineEmits(['leftBtnAction', 'rightBtnAction'])

function leftBtnAction() {
  emits("leftBtnAction");
}

function rightBtnAction() {
  emits("rightBtnAction");
}
</script>

<style>
.confirmation-modal {
  width:  fit-content !important;
  min-width: 400px;
}
</style>
<style scoped>
.modal-class {
  padding: 20px 30px;
}
</style>

<template>
  <GDialog
    content-class="confirmation-modal"
    v-model="localModalState"
    transition="custom-from-bottom-transition"
    :persistent='true'
  >
    <div class="modal-class">
      <div class="modal-header justify-content-center mt-2">
        <label :class="props.titleClass">{{ props.title }}</label>
      </div>

      <div class="modal-body mx-4">
        <label :class="props.subTitleClass">{{ props.subTitle }}</label>
        <slot name="supplementary-item" />

        <div :class="props.noteClass">
          <slot name="note">
            {{ props.note }}
          </slot>
        </div>
      </div>

      <div class="d-flex justify-content-end m-3 mt-4">
        <v-btn
          class="ma-2 exec-btn"
          :class="props.leftBtnClass"
          @click="leftBtnAction"
          :loading="props.leftLoading"
        >
          {{ props.leftBtnName }}
        </v-btn>
        <v-btn
          class="ma-2 reset-btn"
          :class="props.rightBtnClass"
          @click="rightBtnAction"
          :loading="props.rightLoading"
        >
          {{ props.rightBtnName }}
        </v-btn>
      </div>
    </div>
  </GDialog>
</template>
